export default function CustomProgressBar({completed, bgColor, height, borderRadius, isLabelVisible}) {
  return (
    <div style={{background:"#eee", height: height, borderRadius, position:"relative", display:"flex", alignItems:"stretch"}}>
      <div className="completed-progress-xnmrph" style={{width: `${completed}%`}}></div>
    </div>
  )
}